import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index.vue'),
    meta: {
      title: "主页"
    }
  },
  {
    path: "/:secret",
    name: 'indexAdditionalSecret',
    component: () => import('../views/code.vue'),
    meta: {
      title: "主页"
    }
  }
]

const router = new VueRouter({
  // mode: 'history',
  mode: 'history',
  routes
})
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta['title']) {
    document.title = to.meta['title']
  }
  next()
})

export default router
